import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import * as popups from "../../constants/popup-types";
import * as Routes from "../../constants/routes";


class GetUsersApplicationApprovalPage extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'getUsersApplicationApprovalPage';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getUsersApplicationApprovalPage, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setMailLinkPage(this.response.data));
    }

    onFailure(response, methodName = '') {
        this.dispatch(Actions.addPopup({
            type:popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000)
        }));

        setTimeout(()=>{
            window.location = Routes.home;
        }, 1000 * 4);
    }
}


export default GetUsersApplicationApprovalPage;